import React from 'react';
import classnames from 'classnames';
import NoData from '@gp/components/NoData';
import { Button } from 'tea-component';

import type { IBaseProps } from '@home/types/common';

interface IGRNoDataProps extends IBaseProps {
  editable?: boolean;
  // update GR的回调
  onUpdateGR?: () => void;
}

const GRNoData: React.FC<IGRNoDataProps> = (props) => {
  const { style, className, editable, onUpdateGR } = props;

  const editableUI = (
    <>
      No Gate Review info added. Click{' '}
      <Button
        type="link"
        onClick={(e) => {
          e?.stopPropagation();
          onUpdateGR?.();
        }}
      >
        Edit GR
      </Button>{' '}
      to start.
    </>
  );

  const noEditableUI = <>No Gate Review info added.</>;

  return (
    <NoData
      // @ts-ignore
      style={style}
      className={classnames('', className)}
      height={120}
      text={editable ? editableUI : noEditableUI}
    />
  );
};

export default GRNoData;
